import { EQuestionType } from './questionType.model';
import { User } from './user.model';

export interface Answer {
  readonly id: number;
  readonly questionType?: EQuestionType;
  readonly tabularQuestionId?: number;
  readonly modularQuestionGuid?: string;
  readonly modularRowNum?: number;
  readonly boolAnswer?: boolean;
  readonly textAnswer?: string;
  readonly secondaryText?: string;
  readonly dateAnswerNTZ?: Date;
  readonly intAnswer?: number;
  readonly optionItemGuid?: string;
  readonly multiOptionsAnswer?: string;
  readonly questionId: number;
  readonly base64?: string;
  readonly isValid?: boolean;
  readonly wasChange?: boolean;
  readonly files?: FileAnswer[];
  readonly expense?: Expense[];
}
export interface AnswerWithStatus extends Answer {
  readonly status?: EAnswerStatus;
}

export interface FileAnswer {
  readonly id: number;
  readonly base64: string|null;
  readonly fileName: string;
  readonly mimeType: string;
  readonly guid: string | null;
  readonly bucketName?: string | null;
  readonly objectName?: string | null;
  readonly sizeBytes?: number | null;
  previewUrl?: string | null;
}

export enum EAnswerStatus {
  Empty = 1,
  Load,
  Created,
  Changed,
  Saved,
}
export interface Expense {
  id: number;
  answerId: number;
  amount: number | null;
  expenseType: string | null;
  expenseTypeName?: string | null;
  date: Date | null;
  description: string | null;
  documentNumber: string | null;
  files?: FileAnswer[];
  ModularRowNum: number;
  status: EAnswerStatus;
  clientCharge: boolean | null;
  fullcharge: boolean | null;
  clientChargeAmount: number | null;
  approvedAmount?: number | null;
  commentAproval?: string | null;
}
export interface AnswersDetails extends Answer {
  readonly answers: Answer[];
  readonly sentDate: Date;
  readonly approvalDate?: Date;
  readonly user: User;
  readonly recipientId: number;
}
